import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useIntakeQuestionnaireLoading() {
  return useSelector(
    (state: RootState) => state.intakeQuestionnaire.questionnaireDetailsLoading,
  );
}
